import { IconButton, Tooltip } from '@zep-us/zus';
import { SquareStackIcon } from '@zep-us/zus-icons';
import { cn } from '@/utils';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
export const AiBuilderMessageCopyButton = ({
  align = 'start',
  text
}: {
  align?: 'start' | 'end';
  text: string;
}) => {
  const copy = useAiBuilderChatCopy();
  const handleCopy = () => {
    void navigator.clipboard?.writeText(text);
  };
  return <div className={cn('flex w-full', align === 'end' ? 'justify-end' : 'justify-start')} data-sentry-component="AiBuilderMessageCopyButton" data-sentry-source-file="AiBuilderMessageCopyButton.tsx">
      <Tooltip.Provider data-sentry-element="unknown" data-sentry-source-file="AiBuilderMessageCopyButton.tsx">
        <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="AiBuilderMessageCopyButton.tsx">
          <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="AiBuilderMessageCopyButton.tsx">
            <IconButton type="button" variant="transparent" intent="neutral" size="sm" rounded="full" aria-label={copy.copyButton.ariaLabel} onClick={handleCopy} className="text-neutral" data-sentry-element="IconButton" data-sentry-source-file="AiBuilderMessageCopyButton.tsx">
              <SquareStackIcon size="xs" fill="currentColor" data-sentry-element="SquareStackIcon" data-sentry-source-file="AiBuilderMessageCopyButton.tsx" />
            </IconButton>
          </Tooltip.Trigger>
          <Tooltip.Content side="bottom" className="z-[10000]" data-sentry-element="unknown" data-sentry-source-file="AiBuilderMessageCopyButton.tsx">
            <Tooltip.Arrow data-sentry-element="unknown" data-sentry-source-file="AiBuilderMessageCopyButton.tsx" />
            {copy.copyButton.tooltip}
          </Tooltip.Content>
        </Tooltip.Root>
      </Tooltip.Provider>
    </div>;
};